module.exports = "/pages/business/foodslabo/form_image.png";